import { UOMS } from '../constants';

type TParams = {
  mainPriceUnit?: string;
  additionalPriceUnit?: string;
};

export const isCorrectPriceUnitsForLaminateProjectPrice = ({
  mainPriceUnit,
  additionalPriceUnit,
}: TParams) => {
  return (
    (mainPriceUnit === UOMS.CAR && (additionalPriceUnit === UOMS.M2 || additionalPriceUnit === UOMS.MTK)) ||
    ((mainPriceUnit === UOMS.M2 || mainPriceUnit === UOMS.MTK) && additionalPriceUnit === UOMS.CAR)
  );
};
